import { post, get } from '@public/http/request'
import { APICUS } from '@public/utils/const'

export const wxLogin = (params) => post(`${APICUS}/auth/wechat/login`, params) // 扫码登录
export const checkUser = (params) => post(`${APICUS}/auth/wechat/checkUser`, params) // 检验用户
export const sendVerifyCode = (params) => post(`${APICUS}/auth/wechat/sendBindWxSmsCode`, params) // 发送手机验证码
export const bindWeChat = (params) => post(`${APICUS}/auth/wechat/bindWxUser`, params) // 绑定微信